// extracted by mini-css-extract-plugin
export var container = "_4u-0";
export var fallback = "_4u-5";
export var fallbackIcon = "_4u-6";
export var hidden = "_4u-2";
export var image = "_4u-3";
export var loaded = "_4u-4";
export var placeholder = "_4u-1";